import { colors } from '@material-ui/core';
import { alpha } from '@mui/material';

const white = '#FFFFFF';
const whiteOff = 'rgb(234, 242, 249)';
const black = '#000000';
const purpleDark = 'rgb(14, 0, 159)';
const purpleRegular = 'rgb(90, 44, 209)';
const purpleLight = alpha(purpleRegular, 0.3);
const greyRegular = 'rgba(158, 158, 158)';
const greyLight = alpha(greyRegular, 0.4);

export default {
  purpleDark,
  purpleRegular,
  purpleLight,
  black,
  greyRegular,
  greyLight,
  white,
  whiteOff,
  primary: {
    contrastText: white,
    dark: purpleDark,
    main: purpleRegular,
    light: alpha(purpleRegular, 0.7),
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue.A400,
    light: colors.blue.A400,
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  background: {
    default: '#F4F6F8',
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
};
